export const InputParamsError = function ({errorMessage}: {errorMessage: any}) {
  const errors = (errorMessage ?? "")
    .split(",")
    .map((s: string) => s.trim())
    .filter(Boolean);

  // if (errors.length === 0) return null;
  return (
    <>
      <div className="rounded-md border border-red-300 bg-red-50 p-3">
        <div className="mb-2 text-sm font-semibold text-red-800">
          Errors ({errors.length})
        </div>

        <div className="max-h-64 overflow-y-auto rounded-md border border-red-200 bg-white p-2">
          <ul className="list-disc space-y-1 pl-5 text-sm text-red-700">
            {errors.map((msg: string, idx: number) => (
              <li key={idx} className="break-words">
                {msg}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
